// extracted by mini-css-extract-plugin
export default {"my-card":"Recipe_my-card__zeikT","overlay":"Recipe_overlay__HhEF7","my-card_recuadro":"Recipe_my-card_recuadro__646Sy"};